import { trackError } from '~/services/logger/error.utils';
import { isProduction } from '~/apps/Router/router.utils';
import { isTesting } from '~/utils/environment.utils';

interface Params {
    [key: string]: any;
}
export const sendPixelEvent = (params: Params) => {
    if (isTesting()) {
        return;
    }

    params.environment = isProdEnv() ? 'production' : 'staging';

    const queryString = new URLSearchParams({
        ...params,
        randId: crypto.randomUUID()
    }).toString();
    const url = `${getBaseUrl()}?${queryString}`;
    try {
        fetch(url, {
            method: 'get',
            mode: 'no-cors',
            cache: 'no-cache',
            headers: {
                'Cache-Control': 'no-cache, no-store, must-revalidate'
            }
        });
    } catch (e) {
        trackError({
            error: e,
            message: `[Pixel] ${e.message}`
        });
    }
};

const getBaseUrl = () => {
    if (isProdEnv()) {
        return 'https://etp.honeybook.com/etp.png';
    }
    return 'https://etp.stg-us-east-1-v7.honeybook.com/etp.png';
};

const isProdEnv = () => {
    return isProduction() || window.location.host === 'www.honeybook.com';
};
